<template>
    <div :style='styles' class='layer-container' :class="{'layer-selected' : page_builder_mode && layer.id == selected_layer, 'draggable' : page_builder_mode && layer.id == selected_layer}" @click='selectLayer'>
        <div v-if='page_builder_mode && layer.id == selected_layer' class="corner-circle top-left edge-top edge-left"></div>
        <div v-if='page_builder_mode && layer.id == selected_layer' class="corner-circle top-right edge-top edge-right"></div>
        <div v-if='page_builder_mode && layer.id == selected_layer' class="corner-circle bottom-right edge-bottom edge-right"></div>
        <div v-if='page_builder_mode && layer.id == selected_layer' class="corner-circle bottom-left edge-bottom edge-left"></div>

        <TextLayer class='allow-layer-animation' v-if='layer.config.layer_type == "text"' :layer='layer' />
        <ButtonLayer class='allow-layer-animation' v-if='layer.config.layer_type == "button"' :layer='layer' :page_builder_mode='page_builder_mode'/>
    </div>
</template>

<script setup>
import { motion } from "motion-v"
</script>

<script>
import TextLayer from '@/global/components/dynamic_pages/layers/TextLayer.vue';
import ButtonLayer from '@/global/components/dynamic_pages/layers/ButtonLayer.vue';

import {compileStyles} from "@/global/modules/functions.js";
import interact from 'interactjs'

export default {
    components: {TextLayer, ButtonLayer},
    props:['layer', 'page_builder_mode', 'selected_layer', 'element_id', 'zoom', 'pan_enabled'],
    emits: ['selectedLayerListener', 'movedLayerListener'],
    data(){
        return{
            styles:{},
            selected: false,
            currently_dragging: false,
            original_starting_x: 0,
            original_starting_y: 0,
            position_x_percentage: 0,
            position_y_percentage: 0,
            draggable_instance: null,
            snap_to_grid_modifier: null,
            expand_shrink_timeout: null,
            current_drag_direction: '',
            animation_observer: null
        }
    },
    methods:{
        setStyles(){
            if(this.layer.compiled_styles != null){
                if(typeof this.layer.compiled_styles !== 'undefined'){
                    this.styles = this.layer.compiled_styles.container;
                }
            }
        },
        selectLayer(){
            if(this.page_builder_mode){
                if(!this.currently_dragging && !this.pan_enabled){
                    if(!this.selected){
                        this.$emit('selectedLayerListener', this.layer.id);
                        this.selected = true;
                    }
                    else{
                        this.$emit('selectedLayerListener', '');
                        this.selected = false;
                    }
                }
                else{
                }
            }
        },
        calculateInitialPosition(e){
            let scale = this.zoom;
            
            let container_width = document.getElementById(this.element_id).clientWidth;
            let container_height = document.getElementById(this.element_id).clientHeight;

            const layer_width = e.target.clientWidth;
            const layer_height =  e.target.clientHeight;

            let starting_x_percentage = this.layer.styles.left.value.split('%')[0];
            let starting_x_position = (container_width - layer_width) * (starting_x_percentage / 100);

            let starting_y_percentage = this.layer.styles.top.value.split('%')[0];
            let starting_y_position = (container_height - layer_height) * (starting_y_percentage / 100);

            this.original_starting_x = starting_x_position;
            this.original_starting_y = starting_y_position;
        },
        draggableInstance(){
            this.snap_to_grid_modifier = interact.modifiers.snap({
                                            targets: [
                                                interact.snappers.grid({ 
                                                    x: document.getElementById(this.element_id).clientWidth /100, y: 30,
                                                    // limits: {
                                                    //     top: 0,
                                                    //     left: 0,
                                                    //     bottom: document.getElementById(this.element_id).clientWidth - (document.getElementById(this.element_id).clientWidth *0.05),
                                                    //     height:600
                                                    // }
                                                })
                                            ],
                                            range: Infinity,
                                            relativePoints: [ { x: 0.5, y: 0.5 } ], //Snap from center - 0 = left, 0.5 = center, 1 = right
                                            enabled: false
                                        });

            let position = { x: 0, y: 0 }

            document.addEventListener('keydown', (event) =>{
                if (event.shiftKey) {
                    this.snap_to_grid_modifier.enable();
                }
            });

            document.addEventListener('keyup', (event) =>{
                if(event.key == 'Shift'){
                   this.snap_to_grid_modifier.disable();
                }
            });
            document.addEventListener('keydown', (event) =>{
                 if (event.altKey) {
                    this.draggable_instance.resizable().enabled = true
                }
             
            });
            document.addEventListener('keyup', (event) =>{
                if(event.key == 'Alt'){
                    this.draggable_instance.resizable().enabled = false
                }
            });

            this.draggable_instance = interact('.draggable').draggable({
                modifiers: [
                    interact.modifiers.restrictRect ({
                        // restriction: '.element-container',
                    }),
                    this.snap_to_grid_modifier
                ],
                listeners: {
                    start: (e)=> {
                        let starting_positions = this.calculateInitialPosition(e);
                        position.x = this.original_starting_x;
                        position.y = this.original_starting_y;
                        this.currently_dragging = true;
                        this.$emit('movedLayerListener', true);
                    },
                    move: (e)=> {

                        let scale = this.zoom;

                        position.x += (e.dx / scale);
                        position.y += (e.dy /scale);

                        let container_width = document.getElementById(this.element_id).clientWidth;
                        let container_height = document.getElementById(this.element_id).clientHeight;

                        const layer_width = e.target.clientWidth;
                        const layer_height =  e.target.clientHeight;

                        this.position_x_percentage = (((position.x) /( container_width - layer_width)) * 100);
                        this.position_y_percentage = (((position.y) /( container_height - layer_height)) * 100);

                        if(this.position_y_percentage < 0){
                            this.position_y_percentage = 0;
                        }
                        if(this.position_y_percentage > 100){
                            this.position_y_percentage = 100;
                        }

                        if(this.position_x_percentage < 0){
                            this.position_x_percentage = 0;
                        }
                        if(this.position_x_percentage > 100){
                            this.position_x_percentage = 100;
                        }

                        e.target.style.top = ''; //Remove top and left as it will mess things up
                        e.target.style.left = '';

                        e.target.style.transform = `translate(${position.x}px, ${position.y}px)`
                    },
                    end: (e)=> {
                        setTimeout(() => {
                            this.currently_dragging = false;
                            this.$emit('movedLayerListener', false);
                        }, 1);

                        this.layer.styles.translate.value = `translate( -${this.position_x_percentage}%, -${this.position_y_percentage}% )`;
                        this.layer.styles.top.value = `${this.position_y_percentage}%`
                        this.layer.styles.left.value = `${this.position_x_percentage}%`

                        if(typeof this.layer.compiled_styles !== 'undefined'){
                            this.layer.compiled_styles.container = compileStyles(this.layer.styles);
                        }
                    }
                }
            })
            .resizable({
                // edges: { top: '.top-left', left: '.bottom-left', bottom: '.bottom-right', right: '.top-right' },
                //  edges: { top: '.top-left', left: '.bottom-left', bottom: '.bottom-right', right: '.top-right' },
                // edges: { top: true, left: true, bottom: true, right: true },

                /* 
                    Reference for diagonal edges:
                    https://stackoverflow.com/questions/76132184/can-we-make-element-resizable-only-from-corners-and-not-from-anywhere-in-intera 
                */
                edges: {
                    top: '.edge-top',
                    left: '.edge-left',
                    bottom: '.edge-bottom',
                    right: '.edge-right',
                },
                enabled: true,
                listeners: {
                    start: (e)=> {
                        this.currently_dragging = true;
                        this.$emit('movedLayerListener', true);
                    },
                    move: (e)=> {
                        let layer_styles_property = 'button_styles'
                        let compiled_key = 'button';

                        if(this.layer.config.layer_type == 'text'){
                            layer_styles_property = 'text_styles'
                            compiled_key = 'text';
                        }

                        let font_size = this.layer[layer_styles_property].font_size.value;

                        this.layer.compiled_styles[compiled_key] = compileStyles(this.layer[layer_styles_property]);


                        let font_unit =  font_size.match(/[a-zA-Z]+/g);
                        let number = parseFloat(font_size.split(font_unit)[0])

                        let direction = this.calculateDragDirection(e);

                         if(direction == 'expanding' ){
                            number += 0.1;
                        }

                        if(direction == 'shrinking'){
                            if(number > 0.4){
                                number -= 0.1;
                            }
                        }

                        number = number.toFixed(2);

                        this.layer[layer_styles_property].font_size.value =  number + font_unit;
                    },
                      end: (e)=> {
                        setTimeout(() => {
                            this.currently_dragging = false;
                            this.$emit('movedLayerListener', false);
                            
                        }, 1);
                    }
                }
            })
           
        },
        calculateDragDirection(e){

            let direction = '';
            let drag_direction = e.dx + e.dy;

            if(e.edges.bottom && e.edges.right){ //Bottom right
                if(drag_direction > 0){
                     direction = 'expanding';
                }
                else{
                    direction = 'shrinking';
                }
            }
            if(e.edges.bottom && e.edges.left){ //Bottom left
                if(drag_direction < 0 && (e.deltaRect.bottom == 0 || e.deltaRect.bottom > 0)){  // == 0 for windows > 0 for macOS
                     direction = 'expanding';
                }
                if(drag_direction > 0 && (e.deltaRect.bottom == 0 || e.deltaRect.bottom < 0)){  // == 0 for windows > 0 for macOS
                    direction = 'shrinking';
                }
            }
            if(e.edges.top && e.edges.right){ //Top right
     
                  if(drag_direction > 0 && (e.deltaRect.top == 0 || e.deltaRect.top < 0)){ // == 0 for windows < 0 for macOS
                     direction = 'expanding';
                }
                if(drag_direction < 0 && (e.deltaRect.top == 0 || e.deltaRect.top > 0)){ // == 0 for windows > 0 for macOS
                    direction = 'shrinking';
                }
            }
            if(e.edges.top && e.edges.left){ //Top left
                if(drag_direction < 0){
                     direction = 'expanding';
                }
                else{
                    direction = 'shrinking';
                }
            }

            return direction;
        },
        animations(){
            this.animation_observer = new IntersectionObserver((entries) =>{
                entries.forEach((entry)=>{
                        if(entry.target.id == this.layer.id){
                            if(typeof this.layer.animation !== 'undefined'){
                                if(this.layer.animation.type != 'none'){
                                    if(entry.isIntersecting){ //When element is on screen, everything is back to default so appears normally
                                        Object.assign(entry.target.style,{
                                            opacity: 1,
                                            transform: 'translate(0,0)',
                                        });
                                    }
                                    else{ //When the element is hidden off screen / faded out
                                      this.setAnimationOffScreenValues(entry.target);
                                    }
                                }
                            }
                         
                    }

                })
            })
            
            let animatable_layers = document.querySelectorAll(`#${this.layer.id}`);

            animatable_layers.forEach(element => {
                this.animation_observer.observe(element);
            });
        },
        setAnimationOffScreenValues(element){
            let translate_y = 0;
            let translate_x = 0;

            if(this.layer.animation.type == 'fade_up'){
                translate_y = '100%';
            }
            if(this.layer.animation.type == 'fade_down'){
                translate_y = '-100%';
            }

            if(this.layer.animation.type == 'fade_left'){
                translate_x = '100%';
            }
            if(this.layer.animation.type == 'fade_right'){
                translate_x = '-100%';
            }
            
            Object.assign(element.style,{
                opacity: 0,
                transform: `translate(${translate_x}, ${translate_y})`,
                transitionProperty: "opacity, transform",
                transitionDuration: this.layer.animation.duration,
                transitionDelay: this.layer.animation.delay,
                transitionTimingFunction: this.layer.animation.timing_function ?? 'ease'

            });
        },
        setAnimationOnScreenValues(){

        }
    },

    beforeUnmount(){
        let animatable_layers = document.querySelectorAll('.allow-layer-animation');

        if(this.animation_observer != null){
            animatable_layers.forEach(element => {
                this.animation_observer.unobserve(element);
            });
        }
    },
    watch:{
        'layer': {
            handler(){
                this.setStyles();
            },
            deep: true
        },
        'selected_layer': function(oldval, newval){

            if(this.layer.id != newval){ //Set all other layers to false if not clicked
                this.selected = false;
            }

            if(this.selected && this.layer.id == newval){ //If an already selected layer is clicked, once clicked again unselect it
                if(!this.currently_dragging){
                    this.selected = false;
                    this.$emit('selectedLayerListener', '');
                }
            }

            if(this.layer.id == this.selected_layer){
                this.draggableInstance();
            }
        }
    },
    mounted(){
        this.setStyles();

        if(typeof this.layer.animation !== 'undefined'){

            let animatable_layers = document.querySelectorAll('.allow-layer-animation');
    
            animatable_layers.forEach(element => {
                if(this.layer.animation.type != 'none' && element.id == this.layer.id){
                    this.setAnimationOffScreenValues(element);
                }
            });

            this.animations();
        }
    }

}
</script>

<style lang="scss" scoped>

.corner {     width: 10px;
    height: 10px;
    background-color: white;
    position: absolute;
    border-radius: 10px;
    border: #607EF4 1px solid;}

    .edge-top { top: 0 }
    .edge-bottom { bottom: 0 }
    .edge-left { left: 0 }
    .edge-right { right: 0 }

.layer-selected{
    border: 1px #607EF4 solid;
    // z-index: 1; //<-- this causes issues appearing above modal - to change which appears on top of each other change the order of the layers
    touch-action: none;
    user-select: none;
    position: relative;
}

.corner-circle{
    width: 10px;
    height: 10px;
    background-color: white;
    position: absolute;
    border-radius: 10px;
    border: #607EF4 1px solid;
}

.corner-circle.top-left{
    top: -5px;
    left: -5px;
}
.corner-circle.top-right{
    top: -5px;
    right: -5px;
}

.corner-circle.bottom-right{
    bottom: -5px;
    right: -5px;
}

.corner-circle.bottom-left{
    bottom: -5px;
    left: -5px;
}

.layer-hidden{
    // opacity: 0;
    // transition-property: opacity, transform;
    // transition-duration: 1s;
    // filter: blur(5px);
    // transform: translateX(-100%);
    // transform: translateY(-100%);
}

.layer-show{
    // opacity: 1;
    // transition: opacity, transform, filter 1s;
    // filter: blur(0);
    // transform: translateX(0);
    // transform: translateY(0);
}
</style>

<style>
.layer-container>*>p{
    margin: 0;
}
</style>